import React from 'react'
import Dashboard from '../../Screens/BranchManager/Dashboard'
import SalesRecords from '../../Screens/BranchManager/SalesRecords'
import DailyReconciliation from '../../Screens/BranchManager/DailyReconciliation'
import RefundsReturns from '../../Screens/BranchManager/RefundsReturns'
import ReturnCode from '../../Screens/BranchManager/ReturnCode'
import Quotations from '../../Screens/BranchManager/Quotations'
import BranchStock from '../../Screens/BranchManager/BranchStock'
import LowStockAlerts from '../../Screens/BranchManager/LowStockAlerts'
import IncomingTransfers from '../../Screens/BranchManager/IncomingTransfers'
import TransferHistory from '../../Screens/BranchManager/TransferHistory'
import MyRequests from '../../Screens/BranchManager/MyRequests'
import AddExpenses from '../../Screens/BranchManager/AddExpenses'
import ManageExpenses from '../../Screens/BranchManager/ManageExpenses'
import AddExpenseCategory from '../../Screens/BranchManager/AddExpenseCategory'
import ManageExpenseCategory from '../../Screens/BranchManager/ManageExpenseCategory'
import ExpenseReport from '../../Screens/BranchManager/ExpenseReport'
import PriceList from '../../Screens/BranchManager/PriceList'
import Reports from '../../Screens/BranchManager/Reports'
import Profile from '../../Screens/BranchManager/Profile'
import CashReceivedSummary from '../../Screens/BranchManager/CashReceivedSummary'

const Main = ({ activeScreen, isFirstLogin }) => {
  const renderScreen = () => {
    // If first login, only allow profile screen
    if (isFirstLogin && activeScreen !== 'profile') {
      return <Profile />
    }

    switch (activeScreen) {
      case 'dashboard':
        return <Dashboard />
      case 'sales-records':
        return <SalesRecords />
      case 'daily-reconciliation':
        return <DailyReconciliation />
      case 'cash-received-summary':
        return <CashReceivedSummary />
      case 'refunds-returns':
        return <RefundsReturns />
      case 'return-code':
        return <ReturnCode />
      case 'quotations':
        return <Quotations />
      case 'branch-stock':
        return <BranchStock />
      case 'low-stock-alerts':
        return <LowStockAlerts />
      case 'incoming-transfers':
        return <IncomingTransfers />
      case 'my-requests':
        return <MyRequests />
      case 'transfer-history':
        return <TransferHistory />
      case 'add-expenses':
        return <AddExpenses />
      case 'manage-expenses':
        return <ManageExpenses />
      case 'add-expense-category':
        return <AddExpenseCategory />
      case 'manage-expense-category':
        return <ManageExpenseCategory />
      case 'expense-report':
        return <ExpenseReport />
      case 'price-list':
        return <PriceList />
      case 'reports':
        return <Reports />
      case 'profile':
        return <Profile />
      default:
        return <Dashboard />
    }
  }

  return (
<main id="main" className="main">
      {renderScreen()}
</main>
  )
}

export default Main
